import { ChangeDetectionStrategy, Component } from '@angular/core';
import { I2gDialogService } from 'i2g-ng-ui';

@Component({
  selector: 'app-paypal-unlink-dialog',
  templateUrl: './paypal-unlink-dialog.component.html',
  styleUrls: ['./paypal-unlink-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaypalUnlinkDialogComponent {
  constructor(private _dialogService: I2gDialogService) {}

  closeDialog(unlink: boolean) {
    this._dialogService.closeDialog(unlink);
  }
}
